<template>
  <div class="company-observe">
    <div class="company-observe__header">
      <div>
        <h2>企业观察</h2>
        <p>以独立观察身份进入企业管理员后台，不占用或踢出原管理员和客服登录。</p>
      </div>
      <div class="company-observe__search">
        <el-input
          size="small"
          v-model.trim="keyword"
          placeholder="公司名称 / 超级管理员邮箱 / 企业前缀"
          @keyup.enter.native="search"
        ></el-input>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
      </div>
    </div>

    <el-table :data="companies" border v-loading="loading" empty-text="暂无企业数据">
      <el-table-column prop="company" label="公司名称" min-width="180"></el-table-column>
      <el-table-column prop="email" label="超级管理员邮箱" min-width="220"></el-table-column>
      <el-table-column prop="prefix" label="企业前缀" min-width="140"></el-table-column>
      <el-table-column prop="server_uid" label="CRM服务器" width="120"></el-table-column>
      <el-table-column prop="today_session_num" label="当天会话数" width="120" align="center">
        <template scope="scope">
          <span v-if="scope.row.today_session_num !== null">{{scope.row.today_session_num}}</span>
          <el-tooltip v-else content="会话统计暂时不可用" placement="top">
            <span class="company-observe__unavailable">--</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template scope="scope">
          <el-button
            type="primary"
            size="small"
            :loading="observingPrefix === scope.row.prefix"
            @click="observe(scope.row)"
          >观察</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="company-observe__pagination">
      <el-pagination
        layout="total, prev, pager, next"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        @current-change="pageChanged"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword: '',
      companies: [],
      loading: false,
      observingPrefix: '',
      page: 1,
      pageSize: 20,
      total: 0
    }
  },
  created() {
    this.loadCompanies()
  },
  methods: {
    search() {
      this.page = 1
      this.loadCompanies()
    },
    pageChanged(page) {
      this.page = page
      this.loadCompanies()
    },
    loadCompanies() {
      this.loading = true
      this.$ajax.post('/api/observer_companies', {
        keyword: this.keyword,
        page: this.page,
        page_length: this.pageSize
      }).then(res => {
        const data = res.data.data || {}
        this.companies = data.companies || []
        this.total = data.total_num || 0
      }).catch(() => {
        this.$message.error('企业观察列表加载失败')
      }).then(() => {
        this.loading = false
      })
    },
    observe(company) {
      const observerWindow = window.open('about:blank', '_blank')
      this.observingPrefix = company.prefix

      this.$ajax.post('/api/observe_company', {
        server_uid: company.server_uid,
        prefix: company.prefix
      }).then(res => {
        const data = res.data.data
        if (!data || !data.url) {
          throw new Error(res.data.error || '无法创建观察会话')
        }

        if (observerWindow) {
          observerWindow.opener = null
          observerWindow.location.replace(data.url)
        } else {
          this.$message.warning('浏览器阻止了新窗口，请允许弹出窗口后重试')
        }
      }).catch(error => {
        if (observerWindow) observerWindow.close()
        const message = error && error.message ? error.message : '无法创建观察会话'
        this.$message.error(message)
      }).then(() => {
        this.observingPrefix = ''
      })
    }
  }
}
</script>

<style scoped>
.company-observe {
  box-sizing: border-box;
  padding: 24px;
}
.company-observe__header {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.company-observe__header h2 {
  color: #333;
  font-size: 20px;
  font-weight: normal;
  margin: 0 0 8px;
}
.company-observe__header p {
  color: #8492a6;
  font-size: 13px;
  margin: 0;
}
.company-observe__search {
  display: flex;
  gap: 8px;
  width: 430px;
}
.company-observe__pagination {
  margin-top: 20px;
  text-align: right;
}
.company-observe__unavailable {
  color: #bfcbd9;
}
</style>



// WEBPACK FOOTER //
// companyObserve.vue?4cda8952